module.exports = __webpack_public_path__ + "static/media/spectra_s1-pump.14e88ba3.png";